import React from "react";
import { IconProps } from "./IconProps";

const ToolboxIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28 8.25H21.75V7C21.75 6.27065 21.4603 5.57118 20.9445 5.05546C20.4288 4.53973 19.7293 4.25 19 4.25H13C12.2707 4.25 11.5712 4.53973 11.0555 5.05546C10.5397 5.57118 10.25 6.27065 10.25 7V8.25H4C3.53587 8.25 3.09075 8.43437 2.76256 8.76256C2.43437 9.09075 2.25 9.53587 2.25 10V24C2.25 24.4641 2.43437 24.9092 2.76256 25.2374C3.09075 25.5656 3.53587 25.75 4 25.75H28C28.4641 25.75 28.9092 25.5656 29.2374 25.2374C29.5656 24.9092 29.75 24.4641 29.75 24V10C29.75 9.53587 29.5656 9.09075 29.2374 8.76256C28.9092 8.43437 28.4641 8.25 28 8.25ZM11.75 7C11.75 6.66848 11.8817 6.35054 12.1161 6.11612C12.3505 5.8817 12.6685 5.75 13 5.75H19C19.3315 5.75 19.6495 5.8817 19.8839 6.11612C20.1183 6.35054 20.25 6.66848 20.25 7V8.25H11.75V7ZM4 9.75H28C28.0663 9.75 28.1299 9.77634 28.1768 9.82322C28.2237 9.87011 28.25 9.9337 28.25 10V14.25H23.75V13C23.75 12.8011 23.671 12.6103 23.5303 12.4697C23.3897 12.329 23.1989 12.25 23 12.25C22.8011 12.25 22.6103 12.329 22.4697 12.4697C22.329 12.6103 22.25 12.8011 22.25 13V14.25H9.75V13C9.75 12.8011 9.67098 12.6103 9.53033 12.4697C9.38968 12.329 9.19891 12.25 9 12.25C8.80109 12.25 8.61032 12.329 8.46967 12.4697C8.32902 12.6103 8.25 12.8011 8.25 13V14.25H3.75V10C3.75 9.9337 3.77634 9.87011 3.82322 9.82322C3.87011 9.77634 3.9337 9.75 4 9.75ZM28 24.25H4C3.9337 24.25 3.87011 24.2237 3.82322 24.1768C3.77634 24.1299 3.75 24.0663 3.75 24V15.75H8.25V17C8.25 17.1989 8.32902 17.3897 8.46967 17.5303C8.61032 17.671 8.80109 17.75 9 17.75C9.19891 17.75 9.38968 17.671 9.53033 17.5303C9.67098 17.3897 9.75 17.1989 9.75 17V15.75H22.25V17C22.25 17.1989 22.329 17.3897 22.4697 17.5303C22.6103 17.671 22.8011 17.75 23 17.75C23.1989 17.75 23.3897 17.671 23.5303 17.5303C23.671 17.3897 23.75 17.1989 23.75 17V15.75H28.25V24C28.25 24.0663 28.2237 24.1299 28.1768 24.1768C28.1299 24.2237 28.0663 24.25 28 24.25Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ToolboxIcon;
